import { Navigate } from 'react-router-dom';
import { settingsHref } from '@/features/settings/settingsHref';
import { LockedScreen } from '@/session/LockedScreen';
import { useMe } from '@/session/meHooks';
import { StandaloneMain } from '@/shell/StandaloneMain';
import { ReferralPage } from './ReferralPage';

export function ReferralSignedIn() {
  const me = useMe();
  // Outside the shell, so the locked screen brings its own `<main>` and skip link.
  if (me.locked) {
    return (
      <StandaloneMain maxWidth="lg" sx={{ py: 3 }}>
        <LockedScreen />
      </StandaloneMain>
    );
  }
  if (me.tier === 'NONE' || me.tier === 'GUEST') {
    return <Navigate to={settingsHref('subscription')} replace />;
  }
  return <ReferralPage />;
}
